import Icon from 'components/common/Icon';
import IconBackground from '../../../common/icons/IconBackground';

export const HeaderWithEdit = ({
  onClickEdit,
  title,
}: {
  onClickEdit(): void;
  title: string;
}): JSX.Element => {
  return (
    <div className="flex items-center space-x-4">
      <h2 className="text-base font-semibold">{title}</h2>

      <IconBackground onClick={onClickEdit}>
        <div className="w-3 h-3">
          <Icon id="pencil" />
        </div>
      </IconBackground>
    </div>
  );
};
